import { OverlookEntry } from '../../../shared/types/overlookEntry.ts';


interface OverlookStatusProps {
    overlookTable: OverlookEntry[];
    page: number;
    isSingleView?: boolean;
    page1StartColumn?: number;
}

export function OverlookStatus({ overlookTable, page, isSingleView = false, page1StartColumn = 1 }: OverlookStatusProps) {
    const runningCount = overlookTable.filter((it) => it.status === 'OPERATE' || it.status === 'SETUP').length;
    const totalCount = overlookTable.filter((it) => it.status).length;
    const percentRunning = totalCount ? (runningCount / totalCount) * 100 : 0;

    const gridColumn = isSingleView ? page1StartColumn + 4 : page === 1 ? 'col5' : 'col1';
    const gridRow = isSingleView ? '6 / span 1' : page === 1 ? '6 / span 1' : '1 / span 1';

    return (
        <div
            className='overlook-stats'
            style={{
                gridColumn,
                gridRow,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <div style={{ fontSize: '1.5em', fontWeight: 'bold' }}>
                Running: {runningCount} / {totalCount}
            </div>
            <div style={{ fontSize: '6em' }}>{percentRunning.toFixed(0)}%</div>
        </div>
    );
}
